

// Packages
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Container, Form, Icon, Message } from "semantic-ui-react";
import Select from "react-select";
import lodash from "lodash/core";

// Actions
import {
    selectBGPricingFormScheme,
    selectBGPricingFormCountry,

    setBGPricingFormFlatPrice,
    setBGPricingFormVolumeTier,

    addBGPricingFormVolumeTier,
    deleteBGPricingFormVolumeTier,
} from 'veritas/billing-groups/actions/BillingGroupPricingActions';

// Data
import countriesData from 'common/resources/countries.json';

// Local
import * as Validation from "../../../common/utils/Validation";



export default function BillingGroupPricingForm({ ...props }) {
    const dispatch = useDispatch();
    const { formMessage, formWarningNotification, formErrorNotification, formMessageHeader } = useSelector((state) => state.marvel.message);
    const { pricingSchemeObject, pricingSchemeOptions, showModalBGPricingScheme, showModalBGCountryPricing } = useSelector((state) => state.veritas.billingGroupsPricing);

    function countryLabel(code) {
        return lodash.result(lodash.find(countriesData, {
            'value': code
        }), 'label');
    }

    function handleSelectScheme(pricingScheme) {
        dispatch(selectBGPricingFormScheme({ pricingScheme }));
    }

    function handleSelectCountry(country) {
        dispatch(selectBGPricingFormCountry({ country }));
    }

    function handleFlatPriceChange(e, { value }) {
        dispatch(setBGPricingFormFlatPrice({ value }));
    }

    function handleVolumePricingChange(e, { value, name, idx }) {
        dispatch(setBGPricingFormVolumeTier({ value, name, idx }));
    }

    function handleAddVolumeTier() {
        dispatch(addBGPricingFormVolumeTier());
    }

    function handleDeleteVolumeTier() {
        dispatch(deleteBGPricingFormVolumeTier());
    }

    function handleDismiss() {
        Validation.clearMessages();
    }

    return (
        <div className="form-page-container">
            <Container>
                <Form>
                    <Card fluid>
                        <Card.Content>
                            <Form.Group widths="equal">
                                {showModalBGPricingScheme
                                    ? (
                                        <Form.Field required={showModalBGPricingScheme}>
                                            <label>Pricing Scheme</label>
                                            <Select
                                                isSearchable={true}
                                                isClearable={true}
                                                getOptionLabel={option => option.label}
                                                getOptionValue={option => option.value}
                                                options={pricingSchemeOptions}
                                                placeholder="Select A Pricing Scheme"
                                                value={lodash.find(pricingSchemeOptions, {
                                                    value: pricingSchemeObject.pricing_scheme
                                                })}
                                                onChange={handleSelectScheme}
                                            />
                                        </Form.Field>
                                    )
                                    : (
                                        <Form.Input
                                            disabled
                                            type="text"
                                            label="Pricing Scheme"
                                            value={pricingSchemeObject.pricing_scheme}
                                        />
                                    )

                                }
                                {showModalBGCountryPricing || showModalBGPricingScheme
                                    ? (
                                        <Form.Field required>
                                            <label>Country</label>
                                            <Select
                                                isSearchable={true}
                                                isClearable={true}
                                                getOptionLabel={option => option.label}
                                                getOptionValue={option => option.value}
                                                options={countriesData}
                                                placeholder="Select Country"
                                                value={lodash.find(countriesData, {
                                                    value: pricingSchemeObject.country_code
                                                })}
                                                onChange={handleSelectCountry}
                                            />
                                        </Form.Field>
                                    )
                                    : (
                                        <Form.Input
                                            disabled
                                            type="text"
                                            label="Country"
                                            value={pricingSchemeObject.country_code + ' - ' +
                                                countryLabel(pricingSchemeObject.country_code)}
                                            name="country_code"
                                        />
                                    )
                                }
                                {/* if the pricing scheme is flat, we directly expose the pricing input on the form and
                                 capture the value accordingly.
                                 Even though Input types are marked as number, semantic/fomantic input component sends
                                 the value as string. This String is parsed into native js data type Number based when
                                 it is assigned in the reducer.
                                 */}
                                {pricingSchemeObject.pricing_scheme === 'FLAT' ?
                                    <>
                                        <Form.Input
                                            required
                                            type="number"
                                            step="0.1"
                                            label="Price"
                                            placeholder="$"
                                            value={pricingSchemeObject.pricing_json[0].price}
                                            name="price"
                                            onChange={handleFlatPriceChange}
                                        />
                                    </>
                                    : null}
                            </Form.Group>
                            {pricingSchemeObject.pricing_scheme !== "FLAT"
                                ? (
                                    pricingSchemeObject.pricing_json.map((p, idx) => {
                                        return (
                                            <div key={idx} className="volume-country-pricing-edit">
                                                <Form.Group widths="equal" >
                                                    <Form.Input
                                                        disabled={!showModalBGPricingScheme}
                                                        type="number"
                                                        label="Min."
                                                        placeholder="Min."
                                                        value={p.min}
                                                        name={"min"}
                                                        idx={idx}
                                                        onChange={handleVolumePricingChange}
                                                    />
                                                    <Form.Input
                                                        disabled={!showModalBGPricingScheme}
                                                        type="number"
                                                        label="Max."
                                                        placeholder="Max."
                                                        value={p.max !== null ? p.max : 0}
                                                        name={"max"}
                                                        idx={idx}
                                                        onChange={handleVolumePricingChange}
                                                    />
                                                    <Form.Input
                                                        type='number'
                                                        step="0.1"
                                                        label="Price"
                                                        placeholder="$"
                                                        value={p.price}
                                                        name={"price"}
                                                        idx={idx}
                                                        onChange={handleVolumePricingChange}
                                                    />
                                                    {/* Only allow to delete from the last tier upwards and
                                                        do not allow to delete if there is only one tier left. */}
                                                    <div style={{
                                                        alignSelf: "center",
                                                        paddingTop: "20px", cursor: "pointer"
                                                    }}>
                                                        <Icon
                                                            disabled={idx === 0 ||
                                                                idx !== pricingSchemeObject.pricing_json.length - 1}
                                                            idx={idx}
                                                            size={"large"}
                                                            name={"trash alternate"}
                                                            onClick={handleDeleteVolumeTier}
                                                        />
                                                    </div>

                                                </Form.Group>
                                            </div>
                                        )
                                    })
                                )
                                : null
                            }
                            {showModalBGPricingScheme && pricingSchemeObject.pricing_scheme !== "FLAT"
                                ? (
                                    <div>
                                        <Button
                                            content={"Add Volume Tier"}
                                            onClick={handleAddVolumeTier}
                                        />
                                    </div>
                                )
                                : null
                            }
                        </Card.Content>
                    </Card>
                </Form>

                {formWarningNotification || formErrorNotification
                    ? (
                        <div style={{ paddingTop: "30px" }}>
                            <Message
                                error={formErrorNotification}
                                warning={formWarningNotification}
                                header={formMessageHeader}
                                list={formMessage}
                                // hidden={formWarning}
                                visible={formWarningNotification || formErrorNotification}
                                onDismiss={handleDismiss}
                            />
                        </div>
                    )
                    : null}
            </Container>
        </div>
    )
}
